// extracted by mini-css-extract-plugin
export default {"entity":"lsf-entity","entity__info":"lsf-entity__info"};
    if(module.hot) {
      // 1732531518714
      var cssReload = require("/home/kartik/kvr-lsf/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  